import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, Global } from '@emotion/react';
import { GridContainer } from '@lusha-ui/core';
import React from 'react';
import AppContext from './AppContext';
import Wizard from './wizard/Wizard';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import 'reset-css';
function App() {
    return (_jsxs(AppContext, { children: [_jsx(GridContainer, { justifyContent: 'center', alignItems: 'center', css: css `
          height: 100%;
        `, children: _jsx(Wizard, {}) }), _jsx(Global, { styles: `
          #root {
            height: 100%;
          }
          * {
            box-sizing: border-box;
          }
        ` })] }));
}
export default App;
